import { NavLinks } from "./NavLinks.tsx";

export default function Footer() {
  return (
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-cta">
          <div class="footer-cta-text">
            <h2>Most assessments take 30 minutes.</h2>
            <p>20+ years &middot; 500+ clients nationwide &middot; 24/7 monitoring &amp; support</p>
          </div>
          <a href="/contact" class="cta-button themed">
            Request a Technology Assessment
          </a>
        </div>

        <div class="top">
          <a href="/">
            <img
              src="/img/logos/1stagefooterlogo1.svg"
              alt="Gage Technologies Logo"
              class="footer-logo"
            />
          </a>
          <nav class="footer-nav-links">
            <NavLinks />
          </nav>
          <p class="footer-copyright">
            &copy; {new Date().getFullYear()}{" "}
            Gage Technologies. All rights reserved.
          </p>
        </div>

        {
          /* <div class="title">
          <h2>Contact Gage Technologies</h2>
        </div> */
        }

        <div class="bottom">
          <div class="address">
            <p>
              <strong>Headquarters</strong><br />
              215 Mary Ave Suite 304<br />
              Waco, Texas 76701
            </p>
            <p>
              <strong>Vancouver, WA Office</strong><br />
              1499 SE Tech Center Pl Suite 270<br />
              Vancouver, WA 98683
            </p>
            <p>
              <a href="tel:2547723400">254-772-3400</a>
            </p>
          </div>

          <div class="links">
            <ul>
              <li>
                <a href="/contact">Contact Gage Technologies</a>
              </li>
              <li>
                <a href="/services/unified-communications">
                  Unified Communications
                </a>
              </li>
              <li>
                <a href="/services/customer-experience">Customer Experience</a>
              </li>
              <li>
                <a href="/services/network-infrastructure">
                  Network Infrastructure
                </a>
              </li>
              <li>
                <a href="/services/cyber-security">Cyber Security</a>
              </li>
              <li>
                <a href="/services/managed-services-support">
                  Managed Services & Support
                </a>
              </li>
              <li>
                <a href="/services/ai">Artificial Intelligence</a>
              </li>
              <li>
                <a href="/services/carrier-services">Carrier Services</a>
              </li>
            </ul>
            <ul>
              {
                /* <li>
                <a href="/press">Press</a>
              </li>
              <li>
                <a href="/marketing">Marketing</a>
              </li> */
              }
              <li>
                <a
                  href="https://www.linkedin.com/company/gagetech"
                  target="_blank"
                >
                  LinkedIn
                </a>
              </li>
              {
                /* <li>
                <a href="/careers">Careers</a>
              </li>  */
              }
              <li>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
              <li><a href="/careers">Careers</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
